import { render } from "./PosterEditor.vue?vue&type=template&id=39c5a139&scoped=true"
import script from "./PosterEditor.vue?vue&type=script&lang=js"
export * from "./PosterEditor.vue?vue&type=script&lang=js"

import "./PosterEditor.vue?vue&type=style&index=0&id=39c5a139&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c5a139"]])

export default __exports__